import React from 'react'
import moment from 'moment'
import { Modal } from 'sb-modal'
import { useMemo } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import SubscriptionPlan from 'compositions/SubscriptionPlan/SubscriptionPlan'
import { ContentWithLoader } from 'components/_new/ui'

import messages from './messages'
import s from './DowngradeModalView.scss'


const DowngradeModalView: React.FunctionComponent<DowngradeModal.ReturnType> = (props) => {
  const {
    isFetching, plans, selectedPlan, nextBillingDate, productsPerPeriod,
    setSelectedPlan, onContinue, onConfirm, onClose,
  } = props

  const modalText = useMemo(() => ({
    ...messages.text,
    values: {
      productsPerPeriod,
      nextBillingDate: moment(nextBillingDate).format('MMMM D'),
    },
  }), [ productsPerPeriod, nextBillingDate ])

  return (
    <Modal
      className="humbleBgColor"
      title={messages.title}
      text={modalText}
      primaryButton={{
        title: messages.buttonTitle.primary,
        disabled: selectedPlan === productsPerPeriod,
        onClick: onConfirm,
      }}
      ordinaryButton={{
        title: messages.buttonTitle.ordinary,
        onClick: onContinue,
      }}
      onClose={onClose}
      dataTestId="downgradeModal"
    >
      <ContentWithLoader isFetching={isFetching}>
        <div className={s.planContainer}>
          {
            plans && plans.map(({ price, productsPerPeriod }, index) => (
              <Box
                key={index}
                mt={index ? 16 : 40}
              >
                <SubscriptionPlan
                  price={price}
                  active={productsPerPeriod === selectedPlan}
                  productsCount={productsPerPeriod}
                  withBg
                  onSelect={setSelectedPlan}
                  dataTestId="downgradePlan"
                />
              </Box>
            ))
          }
        </div>
      </ContentWithLoader>
    </Modal>
  )
}


export default DowngradeModalView
